import { render, staticRenderFns } from "./ButtonIframe.vue?vue&type=template&id=401c708a&scoped=true"
import script from "./ButtonIframe.vue?vue&type=script&lang=js"
export * from "./ButtonIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401c708a",
  null
  
)

export default component.exports